import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  props: {
    id: String,
    label: String,
    content: String,
  },
  data() {
    return {
      contentHTML: "",
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ header: 2 }, { header: 3 }, { header: 5 }],
        [{ script: "super" }, { script: "sub" }],
      ],
    };
  },
  created() {
    this.setContent();
  },
  methods: {
    setContent() {
      if (this.content !== undefined) {
        this.contentHTML = this.content;
      } else {
        this.contentHTML = "";
      }
    },
  },
  watch: {
    content() {
      this.setContent();
    },
  },
};
